import "../Amc/CompanyListing.css";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, Zoom, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import viewicn from "../Components/Assets/Our Levers/eye.png";
import { MdAddTask } from "react-icons/md";
import { VscTasklist } from "react-icons/vsc";
import x from "../Components/Assets/Management/x-task.png";
import fb from "../Components/Assets/Management/fb-task.png";
import li from "../Components/Assets/Management/linkedin-task.png";
import insta from "../Components/Assets/Management/instagram-task.png";

export function CompanyListing() {
  const navigate = useNavigate();
  const [manualNewTask, setManualNewTask] = useState(false);
  const [submitStatus, setSubmitStatus] = useState("idle");
  const [taskForm, setTaskForm] = useState({
    companyProfileId: "",
    title: "",
    tagline: "",
    taskpurpose: "",
    headline: "",
    offerormessage: "",
    calltoaction: "",
    guidlines: "",
    additionalinfo: "",
    description: "",
    targetPostingDate: "",
    submissionForReview: "",
    currentStatus: "Pending",
    platform_x: false,
    platform_fb: false,
    platform_insta: false,
    platform_li: false,
  });
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setTaskForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const [
    showSectionTwoSelectedCompanyDetail,
    setShowSectionTwoSelectedCompanyDetail,
  ] = useState(false);
  const [companiesWithTasks, setCompaniesWithTasks] = useState([]);

  const [companyProfile, setCompanyProfile] = useState(null);
  const [companyListingWindow, setCompanyListingWindow] = useState(true);
  const fetchCompanyAllDetails = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("You must be logged in to access this page.");
        navigate("/admin/login");
        return;
      }

      const response = await axios.get(
        process.env.REACT_APP_API_URL + "/admin/all-companies",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.status === 200) {
        console.log("Successfull fetch Company Listing Section-2");
        const companies = response.data;

        if (companies.length > 0) {
          setCompaniesWithTasks(companies);
        } else {
          toast.info("No company has tasks.");
        }
      } else {
        toast.error("Failed to fetch company profile");
      }
    } catch (error) {
      console.error("Error fetching company profile:", error);
      toast.error("An error occurred while fetching company details.");
      navigate("/admin/login");
    }
  };

  useEffect(() => {
    fetchCompanyAllDetails();
  }, []);
  const taskHandleSubmit = async (e) => {
    e.preventDefault();
    setSubmitStatus("submitting");
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        toast.error("You must be logged in to create a task");
        navigate("/admin/login");
        return;
      }

      if (
        !taskForm.title ||
        !taskForm.targetPostingDate ||
        !taskForm.submissionForReview
      ) {
        toast.error("Please fill in all required fields");
        setSubmitStatus("idle");
        return;
      }

      // Prepare form data
      const formData = new FormData();
      formData.append("companyProfileId", companyProfile._id); // Use selected company
      formData.append("title", taskForm.title);
      formData.append("tagline", taskForm.tagline);
      formData.append("taskpurpose", taskForm.taskpurpose);
      formData.append("headline", taskForm.headline);
      formData.append("offerormessage", taskForm.offerormessage);
      formData.append("calltoaction", taskForm.calltoaction);
      formData.append("guidlines", taskForm.guidlines);
      formData.append("additionalinfo", taskForm.additionalinfo);
      formData.append("description", taskForm.description);
      formData.append("targetPostingDate", taskForm.targetPostingDate);
      formData.append("submissionForReview", taskForm.submissionForReview);

      // Add referenceImage to the form data if a file is selected
      const referenceImageInput = document.querySelector(
        'input[name="referenceimage"]'
      );
      if (referenceImageInput && referenceImageInput.files[0]) {
        formData.append("referenceImage", referenceImageInput.files[0]);
      }
      // Add these lines:
      formData.append("platform_x", taskForm.platform_x ? "true" : "false");
      formData.append("platform_fb", taskForm.platform_fb ? "true" : "false");
      formData.append(
        "platform_insta",
        taskForm.platform_insta ? "true" : "false"
      );
      formData.append("platform_li", taskForm.platform_li ? "true" : "false");

      // Send the request to the server
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/task/admin-create-task`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data) {
        toast.success("Task created successfully!");
        setSubmitStatus("submitted");

        setTaskForm({
          companyProfileId: "",
          title: "",
          tagline: "",
          taskpurpose: "",
          headline: "",
          offerormessage: "",
          calltoaction: "",
          guidlines: "",
          additionalinfo: "",
          description: "",
          targetPostingDate: "",
          submissionForReview: "",
        });
        setManualNewTask(false);
        // Reset status after a short delay
        setTimeout(() => setSubmitStatus("idle"), 1500);
      }
    } catch (error) {
      console.error("Error creating task:", error);
      toast.error("Error creating task");
      setSubmitStatus("idle");
    }
  };
  // Handler for checkbox changes:
  const handlePlatformCheckbox = (e) => {
    const { name, checked } = e.target;
    setTaskForm((prev) => ({
      ...prev,
      [name]: checked,
    }));
  };
  // Add this helper at the top of your component (before ContentManagement)
  const getTomorrowDate = () => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow.toISOString().split("T")[0];
  };

  return (
    <div className="admin-cmpy-detail">
      {companyListingWindow && (
        <div className="company-listing-container">
          {companiesWithTasks.map((companyData, index) => (
            <div
              key={companyData.company._id}
              className="admin-cmpy-detail-row"
            >
              <ul>
                <li>
                  {index + 1}.{" "}
                  <img
                    src={companyData.company.logo}
                    className="admin-cmpy-logo"
                    alt=""
                  />
                </li>

                <li className="l1">
                  <h2>Name:</h2>
                  <p>{companyData.company.companyName}</p>
                </li>
                <li className="l2">
                  <h2>Mobile No:</h2>
                  <p>{companyData.company.phone}</p>
                </li>
                <li className="l3">
                  <h2>Email:</h2> <p>{companyData.company.email}</p>
                </li>
                <li className="l4">
                  <h2>Tasks:</h2>
                  <p>{companyData.tasks.length}</p>
                </li>
                <li>
                  <button
                    className="manual-add-task"
                    onClick={() => {
                      setCompanyProfile(companyData.company);
                      setManualNewTask(true);
                      setShowSectionTwoSelectedCompanyDetail(false);
                      setCompanyListingWindow(false);
                    }}
                  >
                    Add Task
                  </button>
                </li>
                <li
                  onClick={() => {
                    setCompanyProfile(companyData.company);
                    setShowSectionTwoSelectedCompanyDetail(true);
                    setCompanyListingWindow(false);
                  }}
                >
                  View <img className="eye-icn" src={viewicn} alt="view" />
                </li>
              </ul>
            </div>
          ))}
        </div>
      )}
      {showSectionTwoSelectedCompanyDetail && (
        <div className="admin-company-details-view ">
          <div className="close-button-row">
            <img
              onClick={() => {
                setShowSectionTwoSelectedCompanyDetail(false);
                setCompanyListingWindow(true);
              }}
              width="48"
              height="48"
              src="https://img.icons8.com/fluency/48/delete-sign.png"
              alt="delete-sign"
              className="status-cross-symbol"
            />
          </div>
          <div className="admin-alt-gap">
            <img
              src={companyProfile.logo}
              alt={companyProfile.companyName}
              className="profile-logo"
            />
            <div className="info-group">
              <h3>Company Name</h3>
              <p>{companyProfile.companyName || "N/A"}</p>
            </div>
            <div className="info-group">
              <h3>Doing Business As (DBA)</h3>
              <p>{companyProfile.dba || "N/A"}</p>
            </div>
            <div className="info-group">
              <h3>Federal Tax ID</h3>
              <p>{companyProfile.fedraltaxid || "N/A"}</p>
            </div>
            <div className="info-group">
              <h3>Industry</h3>
              <p>{companyProfile.industry || "N/A"}</p>
            </div>
            <div className="info-group">
              <h3>Email</h3>
              <p>{companyProfile.email || "N/A"}</p>
            </div>
            <div className="info-group">
              <h3>Phone</h3>
              <p>{companyProfile.phone || "N/A"}</p>
            </div>
            <div className="info-group">
              <h3>Website</h3>
              <p>{companyProfile.website || "N/A"}</p>
            </div>
            <div className="info-group">
              <h3>Address Line 1</h3>
              <p>{companyProfile.address1 || "N/A"}</p>
            </div>
            <div className="info-group">
              <h3>Address Line 2</h3>
              <p>{companyProfile.address2 || "N/A"}</p>
            </div>
            <div className="info-group">
              <h3>City</h3>
              <p>{companyProfile.city || "N/A"}</p>
            </div>
            <div className="info-group">
              <h3>State</h3>
              <p>{companyProfile.state || "N/A"}</p>
            </div>
            <div className="info-group">
              <h3>ZIP Code</h3>
              <p>{companyProfile.zip || "N/A"}</p>
            </div>
            <div className="info-group">
              <h3>Country</h3>
              <p>{companyProfile.country || "N/A"}</p>
            </div>
            <div className="info-group">
              <h3>LinkedIn</h3>
              <p>{companyProfile.linkedin || "N/A"}</p>
            </div>
            <div className="info-group">
              <h3>Facebook</h3>
              <p>{companyProfile.facebook || "N/A"}</p>
            </div>
            <div className="info-group">
              <h3>Instagram</h3>
              <p>{companyProfile.insta || "N/A"}</p>
            </div>
            <div className="info-group">
              <h3>X (Twitter)</h3>
              <p>{companyProfile.x || "N/A"}</p>
            </div>
            <div className="info-group">
              <h3>YouTube</h3>
              <p>{companyProfile.youtube || "N/A"}</p>
            </div>
            <div className="info-group">
              <h3>Font Family</h3>
              <p>{companyProfile.fontfamily || "N/A"}</p>
            </div>
            <div className="info-group">
              <h3>Primary Color</h3>
              <p
                style={{
                  backgroundColor: companyProfile.color1 || "#ffffff",
                  borderRadius: "3px",
                  padding: "5px",
                }}
              >
                {companyProfile.color1 || "N/A"}
              </p>
            </div>
            <div className="info-group">
              <h3>Secondary Color</h3>
              <p
                style={{
                  backgroundColor: companyProfile.color2 || "#ffffff",
                  borderRadius: "3px",
                  padding: "5px",
                }}
              >
                {companyProfile.color2 || "N/A"}
              </p>
            </div>
            <div className="info-group">
              <h3>Tertiary Color</h3>
              <p
                style={{
                  backgroundColor: companyProfile.color3 || "#ffffff",
                  borderRadius: "3px",
                  padding: "5px",
                }}
              >
                {companyProfile.color3 || "N/A"}
              </p>
            </div>
          </div>
          <div className="brand-relate-image-container">
            {companyProfile.brandRelateImage1 && (
              <div className="info-group-img">
                <label>Brand Relate Image 1</label>
                <a
                  href={companyProfile.brandRelateImage1}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={companyProfile.brandRelateImage1}
                    alt="Yet to Upload Relate Image"
                    className="profile-logo"
                  />
                </a>
              </div>
            )}

            {companyProfile.brandRelateImage2 && (
              <div className="info-group-img">
                <label>Brand Relate Image 2</label>
                <a
                  href={companyProfile.brandRelateImage2}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={companyProfile.brandRelateImage2}
                    alt={companyProfile.companyName}
                    className="profile-logo"
                  />
                </a>
              </div>
            )}

            {companyProfile.brandRelateImage3 && (
              <div className="info-group-img">
                <label>Brand Relate Image 3</label>
                <a
                  href={companyProfile.brandRelateImage3}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={companyProfile.brandRelateImage3}
                    alt={companyProfile.companyName}
                    className="profile-logo"
                  />
                </a>
              </div>
            )}

            {companyProfile.brandRelateImage4 && (
              <div className="info-group-img">
                <label>Brand Relate Image 4</label>
                <a
                  href={companyProfile.brandRelateImage4}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={companyProfile.brandRelateImage4}
                    alt={companyProfile.companyName}
                    className="profile-logo"
                  />
                </a>
              </div>
            )}

            {companyProfile.brandRelateImage5 && (
              <div className="info-group-img">
                <label>Brand Relate Image 5</label>
                <a
                  href={companyProfile.brandRelateImage5}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={companyProfile.brandRelateImage5}
                    alt={companyProfile.companyName}
                    className="profile-logo"
                  />
                </a>
              </div>
            )}

            {companyProfile.brandRelateImage6 && (
              <div className="info-group-img">
                <label>Brand Relate Image6</label>
                <a
                  href={companyProfile.brandRelateImage6}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    src={companyProfile.brandRelateImage6}
                    alt="Brand Relate Image 6"
                    className="profile-logo"
                  />
                </a>
              </div>
            )}
          </div>
        </div>
      )}
      {manualNewTask && (
        <div className="assign-new-task manual-task-margin">
          <div className="assign-new-task-row">
            <div className="new-task-form-title">
              Add New Task <MdAddTask style={{ marginLeft: "8px" }} />
            </div>
            <img
              onClick={() => {
                setCompanyListingWindow(true);
                setManualNewTask(false);
              }}
              width="25"
              height="40"
              src="https://i.ibb.co/MkR4grRn/close.png"
              alt="delete-sign"
              className="cross-symbol"
            />
          </div>

          <form className="new-task-form" onSubmit={taskHandleSubmit}>
            <div className="new-task-row">
              <div className="new-task-row-input">
                <label htmlFor="title">
                  Task Title: <span className="red-imp">*</span>
                </label>
                <input
                  type="text"
                  name="title"
                  className="new-task-title"
                  placeholder="e.g., Summer Campaign"
                  value={taskForm.title}
                  onChange={handleInputChange}
                />
              </div>

              <div className="new-task-row-input">
                <label htmlFor="tagline">Tagline or Slogan:</label>
                <input
                  type="text"
                  name="tagline"
                  className="new-task-title"
                  placeholder="e.g., Big Deals Ahead"
                  value={taskForm.tagline}
                  onChange={handleInputChange}
                />
              </div>

              <div className="new-task-row-input">
                <label htmlFor="taskpurpose">Task Purpose/Objective:</label>
                <input
                  type="text"
                  name="taskpurpose"
                  className="new-task-title"
                  placeholder="e.g., Launch new product"
                  value={taskForm.taskpurpose}
                  onChange={handleInputChange}
                />
              </div>

              <div className="new-task-row-input">
                <label htmlFor="headline">Main Headline:</label>
                <input
                  type="text"
                  name="headline"
                  className="new-task-title"
                  placeholder="e.g., Meet the New Smartwatch"
                  value={taskForm.headline}
                  onChange={handleInputChange}
                />
              </div>

              <div className="new-task-row-input">
                <label htmlFor="offerormessage">Key Offer or Message:</label>
                <input
                  type="text"
                  name="offerormessage"
                  className="new-task-title"
                  placeholder="e.g., 20% Off Now"
                  value={taskForm.offerormessage}
                  onChange={handleInputChange}
                />
              </div>

              <div className="new-task-row-input">
                <label htmlFor="calltoaction">Tagline for Lead:</label>
                <input
                  type="text"
                  name="calltoaction"
                  className="new-task-title"
                  placeholder="e.g., Shop Now"
                  value={taskForm.calltoaction}
                  onChange={handleInputChange}
                />
              </div>

              <div className="new-task-row-input">
                <label htmlFor="guidlines">Branding Guidelines:</label>
                <input
                  type="text"
                  name="guidlines"
                  className="new-task-title"
                  placeholder="e.g., Use brand colors"
                  value={taskForm.guidlines}
                  onChange={handleInputChange}
                />
              </div>

              <div className="new-task-row-input">
                <label htmlFor="additionalinfo">Additional Information:</label>
                <input
                  type="text"
                  name="additionalinfo"
                  className="new-task-title"
                  placeholder="e.g., Launch on June 10"
                  value={taskForm.additionalinfo}
                  onChange={handleInputChange}
                />
              </div>

              <div className="new-task-row-input">
                <label htmlFor="description">Description:</label>
                <textarea
                  name="description"
                  className="new-task-des"
                  placeholder="e.g., Fun tone, eco-friendly"
                  value={taskForm.description}
                  onChange={handleInputChange}
                ></textarea>
              </div>

              <div className="new-task-row-input">
                <label htmlFor="referenceimage">
                  Reference Flyer or Product:
                </label>
                <input
                  type="file"
                  name="referenceimage"
                  className="img-input"
                  accept="image/*"
                />
              </div>
              <div className="for-date-row add">
                <div className="new-task-input-box">
                  <label
                    htmlFor="submissionForReview"
                    className="new-task-date-label"
                  >
                    Submission for Review:<span className="red-imp">*</span>
                  </label>
                  <input
                    type="date"
                    name="submissionForReview"
                    className="new-task-date"
                    value={taskForm.submissionForReview}
                    onChange={handleInputChange}
                    min={getTomorrowDate()}
                  />
                </div>

                <div className="new-task-input-box">
                  <label
                    htmlFor="targetPostingDate"
                    className="new-task-date-label"
                  >
                    Target Posting Date:<span className="red-imp">*</span>
                  </label>
                  <input
                    type="date"
                    name="targetPostingDate"
                    className="new-task-date"
                    value={taskForm.targetPostingDate}
                    onChange={handleInputChange}
                    min={getTomorrowDate()}
                  />
                </div>
              </div>
              <div className="social-checkbox-container">
                <label className="new-task-date-label">
                  Select Platforms has to Post:
                  <span className="red-imp">*</span>
                </label>
                <div className="social-checkbox">
                  <div class="checkbox-wrapper-12">
                    <div class="cbx">
                      <input
                        id="cbx-12"
                        type="checkbox"
                        name="platform_x"
                        checked={taskForm.platform_x}
                        onChange={handlePlatformCheckbox}
                      />
                      <label for="cbx-12"></label>
                      <svg
                        width="15"
                        height="14"
                        viewbox="0 0 15 14"
                        fill="none"
                      >
                        <path d="M2 8.36364L6.23077 12L13 2"></path>
                      </svg>
                    </div>

                    <svg xmlns="http://www.w3.org/2000/svg" version="1.1">
                      <defs>
                        <filter id="goo-12">
                          <fegaussianblur
                            in="SourceGraphic"
                            stddeviation="4"
                            result="blur"
                          ></fegaussianblur>
                          <fecolormatrix
                            in="blur"
                            mode="matrix"
                            values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 22 -7"
                            result="goo-12"
                          ></fecolormatrix>
                          <feblend in="SourceGraphic" in2="goo-12"></feblend>
                        </filter>
                      </defs>
                    </svg>
                    <img src={x} className="checkbox__textwrapper" />
                  </div>
                  <div className="checkbox-wrapper-12">
                    <div className="cbx">
                      <input
                        id="cbx-fb"
                        type="checkbox"
                        name="platform_fb"
                        checked={taskForm.platform_fb}
                        onChange={handlePlatformCheckbox}
                      />
                      <label htmlFor="cbx-fb"></label>
                      <svg
                        width="15"
                        height="14"
                        viewBox="0 0 15 14"
                        fill="none"
                      >
                        <path d="M2 8.36364L6.23077 12L13 2"></path>
                      </svg>
                    </div>
                    <img
                      src={fb}
                      className="checkbox__textwrapper"
                      alt="Facebook"
                    />
                  </div>
                  <div className="checkbox-wrapper-12">
                    <div className="cbx">
                      <input
                        id="cbx-insta"
                        type="checkbox"
                        name="platform_insta"
                        checked={taskForm.platform_insta}
                        onChange={handlePlatformCheckbox}
                      />
                      <label htmlFor="cbx-insta"></label>
                      <svg
                        width="15"
                        height="14"
                        viewBox="0 0 15 14"
                        fill="none"
                      >
                        <path d="M2 8.36364L6.23077 12L13 2"></path>
                      </svg>
                    </div>
                    <img
                      src={insta}
                      className="checkbox__textwrapper"
                      alt="Instagram"
                    />
                  </div>
                  <div className="checkbox-wrapper-12">
                    <div className="cbx">
                      <input
                        id="cbx-li"
                        type="checkbox"
                        name="platform_li"
                        checked={taskForm.platform_li}
                        onChange={handlePlatformCheckbox}
                      />
                      <label htmlFor="cbx-li"></label>
                      <svg
                        width="15"
                        height="14"
                        viewBox="0 0 15 14"
                        fill="none"
                      >
                        <path d="M2 8.36364L6.23077 12L13 2"></path>
                      </svg>
                    </div>
                    <img
                      src={li}
                      className="checkbox__textwrapper"
                      alt="LinkedIn"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="new-task-row-submit">
              <button
                type="submit"
                className="new-task-row-submit-btn"
                disabled={
                  submitStatus === "submitting" || submitStatus === "submitted"
                }
              >
                {submitStatus === "submitting"
                  ? "Submitting..."
                  : submitStatus === "submitted"
                  ? "Submitted"
                  : "Submit Task"}
                <VscTasklist
                  style={{
                    marginLeft: "8px",
                    height: "30px",
                    width: "30px",
                  }}
                />
              </button>
            </div>
          </form>
        </div>
      )}

      <ToastContainer
        hideProgressBar={false}
        newestOnTop={true}
        transition={Zoom}
      />
    </div>
  );
}
